import {DvirForm} from '../../model/dvir-form';

export class ConfirmDeleteFormDialogData {
  form: DvirForm;

  constructor(form: DvirForm) {
    this.form = form;
  }
}
